var invalidFlag = ":( invalid :(";
// MT 18-May-2004 - For localised date formatting
var _Locale = "";
var _DateFormat = "";
var _TimeFormat = "";
var _PhoneFormat = "";
var _CurrencyDecimalSeparator = "";
var _CurrencyGroupSeparator = "";
var _CurrencySymbol = "";
/**
 * parses the displayed values
 * @param val1 is the formatted value.
 * @param val2 is the second part of the value.
 * An empty string represents a blank second part,
 * a null value represents the absence of a second part.
 * @return the parsed value (as a string).
 * @param formatParams an object containing additional format information.
 * The required properties on the object depend on the type of formatting.
 * The following are needed by Decimal and Currency:
 *	 DecimalPlaces
 * The following are needed by Phone and Mask:
 *	 mask
 *	 maskHint
 */
function parseFormat(formatType, val1, val2, formatParams) {
  var parseFunc;
  if (!formatType) formatType = "";
  switch (formatType.toLowerCase()) {
    case "integer":
      parseFunc = parseInteger;
      break;
    case "short":
      parseFunc = parseShort;
      break;
    case "decimal":
      parseFunc = parseDecimal;
      break;
    case "dateandtime":
      parseFunc = parseDateTime;
      break;
    case "date":
      parseFunc = parseDate;
      break;
    case "time":
      parseFunc = parseTime;
      break;
    case "alphanum":
      parseFunc = parseGeneral;
      break;
    case "phone":
      parseFunc = parseMask;
      break;
    case "mask":
      parseFunc = parseMask;
      break;
    case "currency":
      parseFunc = parseCurrency;
      break;
    case "long":
      parseFunc = parseLong;
      break;
    default:
      parseFunc = parseGeneral;
      break;
  }
  return parseFunc(val1, val2, formatParams);
}

function _isDate(date) {
  var isValidDate = false;
  if (Object.prototype.toString.call(date) === "[object Date]") {
    if (isNaN(date.getTime())) {
      isValidDate = false;
    } else {
      isValidDate = true;
    }
  }

  return isValidDate;
}

/**
	* formats values for display
	* @param data is the string value to be formatted.
	* @param values is an object on which the following properties will be set:
		 edit: the display for the control (Deprecated in favor of val1)
		 time: the display for the time control (Deprecated in favor of val2)
		 val1: the displayed value for the first half of the control
		 val2: the displayed value for the second half of the control
		 justify: either "right" or "left"
	* @param formatParams an object containing additional format information.
	*	The required properties on the object depend on the type of formatting.
	* The following are needed by Decimal and Currency:
	*	 DecimalPlaces
	* The following are needed by Phone and Mask:
	*	 mask
	*	 maskHint
	* The following are needed by Date and DateAndTime
	*	 noDateEntered
	*	noTimeEntered
	* @return the displayed value for the control (the aggregate of the first and second halves)
	*/
function format(formatType, data, values, formatParams) {
  var formatFunc;
  if (!formatType) formatType = "";

  if (!_isDate(data)) {
    // trim spaces:
    data = "" + data;
    if (!formatParams.dontTrim) {
      data = data.replace(/^\s*/, "");
      data = data.replace(/\s*$/, "");
    }
  }

  switch (formatType.toLowerCase()) {
    case "integer":
      formatFunc = formatInteger;
      break;
    case "short":
      formatFunc = formatInteger;
      break; //Setting formatInteger for a short is intentional. A short is an integer type.
    case "decimal":
      data = parseFloat(data).toFixed(formatParams.DecimalPlaces);
      formatFunc = formatDecimal;
      break;
    case "dateandtime":
      formatFunc = formatDateTime;
      break;
    case "date":
      formatFunc = formatDate;
      break;
    case "time":
      formatFunc = formatTime;
      break;
    case "alphanum":
      formatFunc = formatAlphaNum;
      break;
    case "phone":
      formatFunc = formatPhone;
      break;
    case "mask":
      formatFunc = formatMask;
      break;
    case "currency":
      formatFunc = formatCurrency;
      break;
    default:
      formatFunc = formatGeneral;
      break;
  }
  var retval = formatFunc(data, values, formatParams);
  values.val1 = values.edit;
  values.val2 = values.time;
  return retval;
}

//////////////////////////////////////////////////////////////////////////
function parseGeneral(val1, val2, formatParams) {
  return val1;
}

function formatGeneral(data, values, formatParams) {
  if (values.edit != undefined) values.edit = data;

  return data;
}

//////////////////////////////////////////////////////////////////////////

/** See formatGeneral for a description */
function formatAlphaNum(data, values, formatParams) {
  if (values.edit != undefined && values.justify != undefined) {
    var pattern = /^-?\d*\.?\d*$/;
    values.justify = pattern.test(data) ? "right" : "left";
    values.edit = data;
  }
  return data;
}

/** See parseGeneral for a description */
function parseInteger(val1, val2, formatParams) {
  val1 = "" + val1;
  if (val1.length == 0) return "";

  var val = parseInt(val1, 10);

  if (isNaN(val)) {
    return invalidFlag;
  }
  // javascript parses as long integers, but valid integers on the
  // server must be 32 bits.
  else if (val > 0x7fffffff || val < -0x80000000) {
    return invalidFlag;
  } else {
    return val + "";
  }
}

function parseShort(val1, val2, formatParams) {
  val1 = "" + val1;
  if (val1.length == 0) return "";

  var val = parseInt(val1, 10);

  if (isNaN(val)) {
    return invalidFlag;
  }
  // javascript parses as long integers, but valid shorts on the
  // server must be 16 bits.
  else if (val > 0x7fff || val < -0x8000) {
    return invalidFlag;
  } else {
    return val + "";
  }
}

function parseLong(val1, val2, formatParams) {
  if (val1.length == 0) return "";

  var val = parseInt(val1, 10);

  if (isNaN(val)) {
    return invalidFlag;
  }
  return val + "";
}

/** See parseGeneral for a description */
function parseDecimal(val1, val2, formatParams) {
  if (val1.length == 0) return "";

  // Just calling the parseCurrency method should work also.
  return parseCurrency(val1, val2, formatParams);

  /*
	var val = parseFloat(val1);
	if (isNaN(val))
		return invalidFlag;
	else
		return val+"";
*/
}

function isInvalidString(data) {
  return data && typeof data === "string" && data === invalidFlag;
}

/** See parseGeneral for a description */
function parseCurrency(val1, val2, formatParams) {
  val1 = "" + val1;
  if (isInvalidString(val1)) {
    val1 = val2.edit;
  }

  // Internationalisation
  // Objective - to interpret Currency string back to floating value
  // 1. The decimal and thousands separator get passed from Core
  // 2. Loop through each character to return all digits and the decimal symbol.

  // 1.
  var cds = getCurrencyDecimalSeparator();
  var cgs = getCurrencyGroupSeparator();

  // 2. Parse by own logic because RegEx does not do what we want with unicode characters.
  var i, cp, retval;
  var gotfirstdigit = false;
  var gotcds = false;
  retval = "";
  for (i = 0; i < val1.length; i++) {
    cp = val1.charAt(i);
    if (
      cp == "0" ||
      cp == "1" ||
      cp == "2" ||
      cp == "3" ||
      cp == "4" ||
      cp == "5" ||
      cp == "6" ||
      cp == "7" ||
      cp == "8" ||
      cp == "9"
    ) {
      gotfirstdigit = true;
      retval = retval + cp;
    } else if (cp == cds && !gotcds) {
      gotcds = true;
      retval = retval + cds;
    } else if ((cp == "(" || cp == "-") && !gotfirstdigit) {
      retval = retval + "-";
    } else if (cp == cgs) {
    } else {
      if (gotfirstdigit) break;
    }
  }

  return retval;
}

/** See formatGeneral for a description */
function formatInteger(data, values, formatParams) {
  var temp = formatParams.DecimalPlaces;
  formatParams.DecimalPlaces = 0;
  var retval = formatDecimal(data, values, formatParams);
  formatParams.DecimalPlaces = temp;
  return retval;
}

/** See formatGeneral for a description */
/* formatParams should have a "DecimalPlaces" property */
function formatDecimal(data, values, formatParams) {
  var dot = getCurrencyDecimalSeparator();
  var comma = getCurrencyGroupSeparator();
  var decimalPlaces = parseInt("" + formatParams.DecimalPlaces, 10);

  // have the default be "."
  if (dot == "") dot = ".";

  // NOTE:
  // The usual idiom for rounding decimals is
  // Math.round(num * Math.pow(10, places))/Math.pow(10, places).
  //
  // Aside from being ugly, it doesn't actually work, for example on 35.605, rounded to two places.
  // The following works, but is admittedly even uglier.

  // NOTE:
  // It was decided to use the "round to even" algorithm for handling midpoint rounding, system-wide.
  // This was to be consistent with earlier versions.

  var strValue = "";

  data = parseDecimal(data, values, formatParams);

  // remove all spaces
  data = data.replace(/\s/g, "");

  var dataCopy = data;
  // Just remove thousand separator
  data = data.replace(comma, "");

  // verify a valid value
  var isValid = true;
  // look for invalid characters
  isValid = isValid && data.match(new RegExp("[^-0-9\\" + dot + "]")) == null;
  // look for multiple decimal points
  isValid = isValid && data.indexOf(dot) == data.lastIndexOf(dot);
  // look for negative in the wrong place
  isValid = isValid && data.indexOf("-") < 1;
  // empty string is invalid
  isValid = isValid && data.length > 0;

  if (isValid) {
    var numString = dataCopy;

    // remove the negative sign; add it back again later if necessary.
    var isNegative = false;
    if (numString.substring(0, 1) == "-") {
      isNegative = true;
      numString = numString.substring(1);
    }

    // make sure we have at least one zero at the start for processing
    numString = "0" + numString;

    // find where the dot is, and remove it.
    var dotPos = numString.indexOf(dot);
    if (dotPos == -1) {
      dotPos = numString.length;
    } else {
      numString =
        numString.substring(0, dotPos) + numString.substring(dotPos + 1);
    }

    // roundPoint is the index of the first omitted digit.
    var roundPoint = dotPos + decimalPlaces;

    // pad with zeros
    while (numString.length < roundPoint + 1) {
      numString += "0";
    }

    // get the part to keep as an integer.
    var numStringToIncrement = parseInt(numString.substring(0, roundPoint), 10);

    // add one if we should round up.
    if (numString.substring(roundPoint, roundPoint + 1) > "5") {
      // round up if the round point is greater than 5.
      numStringToIncrement++;
    } else if (numString.substring(roundPoint, roundPoint + 1) == "5") {
      // round up if the round point is equal to 5, and there is an odd number below.
      if (numStringToIncrement % 2 == 1) {
        numStringToIncrement++;
      } else {
        // round up if there are any non-zero digits after the 5.
        var inc = false;
        for (var i = roundPoint + 1; i < numString.length; i++) {
          if (numString.substring(i, i + 1) != "0") {
            inc = true;
            break;
          }
        }
        if (inc) {
          numStringToIncrement++;
        }
      }
    }

    // convert back to a string.
    strValue = numStringToIncrement.toString();

    // pad with leading zeros as necessary
    while (strValue.length < decimalPlaces + 1) {
      strValue = "0" + strValue;
    }

    // re-insert the decimal point
    if (decimalPlaces > 0) {
      strValue =
        strValue.substring(0, strValue.length - decimalPlaces) +
        "." +
        strValue.substring(strValue.length - decimalPlaces, strValue.length);
    }

    // replace the sign.
    if (isNegative) {
      strValue = "-" + strValue;
    }

    // set the edit box value.
    if (values.edit != undefined) {
      values.edit = strValue;
    }
  } else if (data != "" && data != "undefined") {
    //openMessageBox("Warning", "Invalid format", "'" + data + "' is not a valid decimal.", _currentViewId);
    openMessageBox(
      resx.GetString("View", "WarningTitle"),
      resx.GetString("View", "InvalidLabel"),
      resx.Format(resx.GetString("View", "DecimalError"), data),
      _currentViewId
    );
  } else if (strValue == "") {
    values.edit = "";
  }

  return strValue;
}

/** See formatGeneral for a description */
function formatCurrency(data, values, formatParams) {
  if (data.length == 0) return "";

  // Remove the currency symbol.
  var dollar = getCurrencySymbol();
  data = data.replace(dollar, "");

  // data could contain ()  so we need to get the real number
  var num = parseCurrency(data, undefined, undefined);

  var strValue = formatDecimal(num, values, formatParams);

  if (strValue != "") {
    if (getLocaleSpecifier() != "en-GB") {
      // using vbscript to format currency
      if (strValue.substring(0, 1) == "-") {
        //Handle the negative numbers by passing the positive value
        strValue =
          "-" +
          Globalize.format(
            parseFloat(strValue.substr(1)),
            "c" + formatParams.DecimalPlaces,
            getLocaleSpecifier()
          );
      } else {
        strValue = Globalize.format(
          parseFloat(strValue),
          "c" + formatParams.DecimalPlaces,
          getLocaleSpecifier()
        );
      }
    } else {
      if (strValue.substring(0, 1) == "-") {
        //Handle the negative numbers by passing the positive value
        strValue = strValue.replace("-", "-" + dollar);
      } else {
        strValue = dollar + strValue;
      }
    }
  }

  if (values.edit != undefined) values.edit = strValue;

  return strValue;
}

//////////////////////////////////////////////////////////////////////////

/** See parseGeneral for a description */
function parseDate(val1, val2, formatParams, returnDateObj) {
  if (val1 && _isDate(val1)) {
    return formatActualDateTime(val1, false);
  }

  var dateParts = _getDateParts(val1);
  var format = getDateFormat();
  // Parse date format to determine what order to expect the date parts, ie. dmy oy mdy or ydm or ymd
  var datePos = -1;
  var monthPos = -1;
  var yearPos = -1;
  var pos = 0;
  var c_datePattern = "";
  var lcformat = format.toLowerCase();
  for (var i = 0; i < lcformat.length; i++) {
      var cChar = lcformat[i];
      if (cChar == "d" && datePos == -1) {
          datePos = pos;
          pos++;
      } else if (cChar == "m" && monthPos == -1) {
          monthPos = pos;
          pos++;
      } else if (cChar == "y" && yearPos == -1) {
          yearPos = pos;
          pos++;
      }
  }


  // For all cultures assume day, month are entered (in this order) when full date is not specified.
  var dateEntered = true;
  if (dateParts == null || (dateParts.length == 1 && dateParts[0] == "")) dateParts = [];
  var now = new Date();
  var a_date;
  var a_month;
  var a_year;
  switch (dateParts.length) {
    case 0:
      dateEntered = false;
      break;
    case 1:
      // Just day entered
        if (val1.length == 6 || val1.length == 8) {
            var singleDateSplit = [];

            var lastindex = 0;
            for (var i = 0; i < 3; i++) {
              var advance = 2;
              if (yearPos >= 0 && i == yearPos && val1.length == 8) {
                advance = 4;
              }
              singleDateSplit.push(val1.substring(lastindex, lastindex + advance));
              lastindex = lastindex + advance;
            }
            if (datePos >= 0 && monthPos >= 0 && yearPos >= 0) {
                a_date = singleDateSplit[datePos];
                a_month = singleDateSplit[monthPos];
                a_year = singleDateSplit[yearPos];
            } else {
                a_date = singleDateSplit[1];
                a_month = singleDateSplit[0];
                a_year = singleDateSplit[2];
            }
            break;
        } else if (val1.length == 4) {
            var singleDateSplit = [];
            var lastindex = 0;
            var singleDMYear = new Date().getFullYear();
            for (var i = 0; i < 3; i++) {
              if (yearPos >= 0 && i == yearPos) {
                singleDateSplit.push(singleDMYear);
                continue;
              }
              singleDateSplit.push(val1.substring(lastindex, lastindex + 2));
              lastindex = lastindex + 2;
            }

            var singleDMDay = 0;
            var singleDMMonth = 0;
            if (datePos >= 0 && monthPos >= 0) {
              singleDMDay = parseInt(singleDateSplit[datePos]);
              singleDMMonth = parseInt(singleDateSplit[monthPos]);
            }
            a_date = singleDMDay;
            a_month = singleDMMonth;
            a_year = singleDMYear;  
            
            break;
        } else {
            a_date = dateParts[0];
            a_month = now.getMonth() + 1;
            a_year = now.getFullYear();
            break;
        }
    case 2:
      // Day and month entered
      if (datePos > monthPos) {
        // MD
        a_date = dateParts[1];
        a_month = dateParts[0];
      } else {
        // DM
        a_date = dateParts[0];
        a_month = dateParts[1];
      }
      a_year = now.getFullYear();
      break;
    case 3:
      a_date = dateParts[datePos];
      a_month = dateParts[monthPos];
      a_year = dateParts[yearPos];
      break;
    default:
      //case 4:
      //case 5:
      if (yearPos == 0) {
        a_year = parseInt(dateParts[0] + "" + dateParts[1], 10);
        if (datePos > monthPos) {
          // YMD
          a_date = dateParts[3];
          a_month = dateParts[2];
        } else {
          // YDM
          a_date = dateParts[2];
          a_month = dateParts[3];
        }
      } else if (yearPos == 2) {
        a_year = parseInt(dateParts[2] + "" + dateParts[3], 10);
        if (datePos > monthPos) {
          // MDY
          a_date = dateParts[1];
          a_month = dateParts[0];
        } else {
          // DMY
          a_date = dateParts[0];
          a_month = dateParts[1];
        }
      }
      break;
    //RG - Always attempt to parse the date HPS-65152 - default: return invalidFlag;
  }
  //Validate the minimum year for Sql DateTime
  if (!isNaN(a_year)) {
    a_year = parseInt(a_year, 10).validateMinimumYear();
  }

  var retval;
  if (dateEntered) {
    // Re-format the date based on format
    var corrected_month = _correctMonth(a_month);
    var aa_date = new Date(a_year,corrected_month, a_date);
    if (returnDateObj) {
      retval = aa_date;
    } else {
      retval = FormatLocaleDate(aa_date, getDateFormat());
    }
  } else {
    retval = "";
  }

  return retval;
}

// ------------------------------------------------------------------
// Utility functions for parsing in getDateFromFormat()
// ------------------------------------------------------------------
function LZ(x) {
  return (x < 0 || x > 9 ? "" : "0") + x;
}
var MONTH_NAMES = new Array(
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
);
var DAY_NAMES = new Array(
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sun",
  "Mon",
  "Tue",
  "Wed",
  "Thu",
  "Fri",
  "Sat"
);

function _isInteger(val) {
  var digits = "1234567890";
  for (var i = 0; i < val.length; i++) {
    if (digits.indexOf(val.charAt(i)) == -1) {
      return false;
    }
  }
  return true;
}
function _getInt(str, i, minlength, maxlength) {
  for (var x = maxlength; x >= minlength; x--) {
    var token = str.substring(i, i + x);
    if (token.length < minlength) {
      return null;
    }
    if (_isInteger(token)) {
      return token;
    }
  }
  return null;
}

function _getDateParts(dateval) {
    var separator = "";
    var dmy = ["d", "m", "y"];
    // Get localised date format (no time)
    var format = getDateFormat();
    // Find the separator, by removing whitespace and "d m y"
    var lformat = format.toLowerCase();
    for (var i = 0 ; i < dmy.length ; i++) {
        var splitFormat = lformat.split(dmy[i]);
        lformat = splitFormat.join("");
    }
    separator = lformat[0];
    var trimmedDate = dateval.replace(/\s/g, "");
    var dateParts = trimmedDate.split(separator);

    // Remove empty parts
    var datePartsNonEmpty = [];
    for (var i = 0 ; i < dateParts.length ; i++) {
        if (dateParts[i] != '') {
            datePartsNonEmpty.push(dateParts[i]);
        }
    }
    return datePartsNonEmpty;
}

function _correctMonth(month) {
    if (!isNaN(month)) {
        // correct as index
        month--;
    } else {
        // Month is a string, correct it to get a numerical value
        month = new Date(Date.parse(month + "1, 2000")).getMonth();
    }
    return month;
}

// ------------------------------------------------------------------
// getDateFromFormat( date_string , format_string )
//
// This function takes a date string and a format string. It matches
// If the date string matches the format string, it returns the
// getTime() of the date. If it does not match, it returns 0.
// ------------------------------------------------------------------
// ------------------------------------------------------------------
// getDateFromFormat( date_string , format_string )
//
// This function takes a date string and a format string. It matches
// If the date string matches the format string, it returns the
// getTime() of the date. If it does not match, it returns 0.
// -----------------------------------------------------------------
function getDateFromFormat(val, format) {
  if (val == undefined) return NaN;

  if (_isDate(val)) {
    return val.getTime();
  }

  val = val + "";
  format = format + "";
  var i_val = 0;
  var i_format = 0;
  var c = "";
  var token = "";
  var token2 = "";
  var x, y;
  var now = new Date();
  var year = now.getYear();
  var month = now.getMonth() + 1;
  var date = 1;
  var hh = 0;
  var mm = 0;
  var ss = 0;
  //	var hh=now.getHours();
  //	var mm=now.getMinutes();
  //	var ss=now.getSeconds();

  var ampm = "";
  var gotMinutes = false;
  var containsSeconds = true;

  while (i_format < format.length) {
    // Get next token from format string
    c = format.charAt(i_format);
    token = "";
    while (format.charAt(i_format) == c && i_format < format.length) {
      token += format.charAt(i_format++);
    }

    if (token == "-" && val.indexOf("/") > 0) {
      val = val.split("/").join("-");
    }

    // Extract contents of value based on format token
    if (token == "yyyy" || token == "yy" || token == "y") {
      if (token == "yyyy") {
        x = 4;
        y = 4;
      }
      if (token == "yy") {
        x = 2;
        y = 4;
      }
      if (token == "y") {
        x = 1;
        y = 4;
      }
      year = _getInt(val, i_val, x, y);
      if (year == null) {
        return NaN;
      }
      i_val += year.length;
      if (year.length <= 2) {
        // if year is two digits then use current century
        year = Math.floor(now.getFullYear() / 100) * 100 + (year - 0);
      }
    } else if (token == "MMM" || token == "NNN") {
      month = 0;
      for (var i = 0; i < MONTH_NAMES.length; i++) {
        var month_name = MONTH_NAMES[i];
        if (
          val.substring(i_val, i_val + month_name.length).toLowerCase() ==
          month_name.toLowerCase()
        ) {
          if (token == "MMM" || (token == "NNN" && i > 11)) {
            month = i + 1;
            if (month > 12) {
              month -= 12;
            }
            i_val += month_name.length;
            break;
          }
        }
      }
      if (month < 1 || month > 12) {
        return NaN;
      }
    } else if (token == "EE" || token == "E") {
      for (var i = 0; i < DAY_NAMES.length; i++) {
        var day_name = DAY_NAMES[i];
        if (
          val.substring(i_val, i_val + day_name.length).toLowerCase() ==
          day_name.toLowerCase()
        ) {
          i_val += day_name.length;
          break;
        }
      }
    } else if (token == "MM" || token == "M") {
      month = _getInt(val, i_val, token.length, 2);
      if (month == null) month = _getInt(val, i_val, 1, 2);
      if (month == null || month < 1 || month > 12) {
        return NaN;
      }
      i_val += month.length;
    } else if (token == "dd" || token == "d") {
      date = _getInt(val, i_val, token.length, 2);
      if (date == null || date < 1 || date > 31) {
        return NaN;
      }
      i_val += date.length;
    } else if (token == "hh" || token == "h") {
      // Since the leading zero is often dropped for "hh", if null try for "h".
      var hh_tmp = _getInt(val, i_val, token.length, 2);
      if (hh_tmp == null && token.length == 2) hh = _getInt(val, i_val, 1, 2);
      else hh = hh_tmp;
      if (hh == null || hh < 1 || hh > 12) {
        return NaN;
      }
      i_val += hh.length;
    } else if (token == "HH" || token == "H") {
      var hh_tmp = _getInt(val, i_val, token.length, 2);
      if (hh_tmp == null && token.length == 2) hh = _getInt(val, i_val, 1, 2);
      else hh = hh_tmp;
      if (hh == null || hh < 0 || hh > 23) {
        return NaN;
      }
      i_val += hh.length;
    } else if (token == "KK" || token == "K") {
      hh = _getInt(val, i_val, token.length, 2);
      if (hh == null || hh < 0 || hh > 11) {
        return NaN;
      }
      i_val += hh.length;
    } else if (token == "kk" || token == "k") {
      hh = _getInt(val, i_val, token.length, 2);
      if (hh == null || hh < 1 || hh > 24) {
        return NaN;
      }
      i_val += hh.length;
      hh--;
    } else if (token == "mm" || token == "m") {
      gotMinutes = true;
      mm = _getInt(val, i_val, token.length, 2);
      if (mm == null || mm < 0 || mm > 59) {
        return NaN;
      }
      i_val += mm.length;
    } else if (token == "ss" || token == "s") {
      // Sometimes the seconds are dropped
      if (containsSeconds) {
        ss = _getInt(val, i_val, token.length, 2);
        if (ss == null || ss < 0 || ss > 59) {
          return NaN;
        }
        i_val += ss.length;
      } else ss = 0;
    } else if (token == "a" || token == "tt") {
      if (val.substring(i_val, i_val + 2).toLowerCase() == "am") {
        ampm = "AM";
      } else if (val.substring(i_val, i_val + 2).toLowerCase() == "pm") {
        ampm = "PM";
      }
      //else {return 0;}
      i_val += 2;
    } else {
      // if we get past end of the string then finish
      if (val.length > 0 && val.length == i_val) break;
      if (val.substring(i_val, i_val + token.length) != token) {
        if (gotMinutes && val.substring(i_val, i_val + token.length) == " ") {
          containsSeconds = false;
          //i_val+=token.length;
        } else {
          return NaN;
        }
      } else {
        i_val += token.length;
      }
    }
  }

  // If there are any trailing characters left in the value, it doesn't match
  if (i_val != val.length) {
    return NaN;
  }
  // Is date valid for month?
  if (month == 2) {
    // Check for leap year
    if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
      // leap year
      if (date > 29) {
        return NaN;
      }
    } else {
      if (date > 28) {
        return NaN;
      }
    }
  }
  if (month == 4 || month == 6 || month == 9 || month == 11) {
    if (date > 30) {
      return NaN;
    }
  }
  // Correct hours value
  if (hh < 12 && ampm == "PM") {
    hh = hh - 0 + 12;
  } else if (hh > 11 && ampm == "AM") {
    hh -= 12;
  }
  var newdate = new Date(year, month - 1, date, hh, mm, ss);

  return newdate.getTime();
}

//We always want to keep a minimum date time
if (!Number.prototype.validateMinimumYear) {
  //Validate the minimum year for use in the system
  Number.prototype.validateMinimumYear = function() {
    if (this < 1800) {
      if (this < 100) {
        //Set to the next reasonable date assuming we are working from this year
        //i.e 00 = 2000, etc.
        var currentEntry = this;
        return (currentEntry =
          Math.floor(new Date().getFullYear() / 100) * 100 +
          (currentEntry - 0));
      } else {
        return 1800;
      }
    }
    return this;
  };
}
function formatActualDateTime(date, includeTime) {
  // TODO:  This really needs to be done correctly
  var retval;
  //TODO: var aa_date;
  var dateEntered = date.getDate() > 0;

  if (dateEntered && includeTime) {
    //TODO:aa_date = new Date(a_year,a_month-1,a_date,timeParts[0],timeParts[1],timeParts[2]);
    retval = FormatLocaleDate(date, getDateTimePattern());
  } else if (dateEntered) {
    // Re-format the date based on format
    //TODO:aa_date = new Date(a_year,a_month-1,a_date);
    retval = FormatLocaleDate(date, getDateFormat());
  } else if (includeTime) {
    //TODO:aa_date = new Date(now.getFullYear(),now.getMonth(),now.getDate(),timeParts[0],timeParts[1],timeParts[2]);
    retval = FormatLocaleDate(date, getDateTimePattern());
  }
  return retval;
}
/** See parseGeneral for a description */
function parseDateTime(val1, val2, formatParams) {
  if (val1 && _isDate(val1)) {
    return formatActualDateTime(val1, true);
  }
  if (val2 == null || val2 == "") {
    var spacepos = val1.indexOf(" ");
    if (spacepos > 0) {
      val2 = val1.substring(spacepos + 1);
      val1 = val1.substring(0, spacepos);
    } else {
      val2 = "";
    }
  }
  var format = getDateFormat();
  var pattern = /\d{1,2}/g;
  var dateParts = _getDateParts(val1);
  var now = new Date();
  // Parse date format to determine what order to expect the date parts, ie. dmy oy mdy or ydm or ymd
  var datePos = -1;
  var monthPos = -1;
  var yearPos = -1;
  var pos = 0;
  var c_datePattern = "";
  var lcformat = format.toLowerCase();
  for (var i = 0; i < lcformat.length; i++) {
    c_datePattern = lcformat.substring(i, i + 1);
    if (datePos != -1 && monthPos != -1 && yearPos != -1) break;
    if (c_datePattern == "d" && datePos < 0) {
      datePos = pos;
      pos++;
    }
    if (c_datePattern == "m" && monthPos < 0) {
      monthPos = pos;
      pos++;
    }
    if (c_datePattern == "y" && yearPos < 0) {
      yearPos = pos;
      pos++;
    }
  }

  // For all cultures assume day, month are entered (in this order) when full date is not specified.
  var dateEntered = true;
  if (dateParts == null) {
    dateParts = [];
  }
  var a_date;
  var a_month;
  var a_year;

  switch (dateParts.length) {
    case 0:
      dateEntered = false;
      break;
    case 1:
        // Just day entered
        if (val1.length == 6 || val1.length == 8) {
            var singleDateSplit = [];

            for (var i = 0 ; i < 2 ; i++) {
                var c = i * 2;
                singleDateSplit.push(val1.substring(c, c + 2));
            }
            singleDateSplit.push(val1.substring(4));
            if (datePos >= 0 && monthPos >= 0 && yearPos >= 0) {
                a_date = singleDateSplit[datePos];
                a_month = singleDateSplit[monthPos];
                a_year = singleDateSplit[yearPos];
            } else {
                a_date = singleDateSplit[1];
                a_month = singleDateSplit[0];
                a_year = singleDateSplit[2];
            }
            break;
        } else if (val1.length == 4) {
          var singleDateSplit = [];
          var lastindex = 0;
          var singleDMYear = new Date().getFullYear();
          for (var i = 0; i < 3; i++) {
            if (yearPos >= 0 && i == yearPos) {
              singleDateSplit.push(singleDMYear);
              continue;
            }
            singleDateSplit.push(val1.substring(lastindex, lastindex + 2));
            lastindex = lastindex + 2;
          }

          var singleDMDay = 0;
          var singleDMMonth = 0;
          if (datePos >= 0 && monthPos >= 0) {
            singleDMDay = parseInt(singleDateSplit[datePos]);
            singleDMMonth = parseInt(singleDateSplit[monthPos]);
          }
          a_date = singleDMDay;
          a_month = singleDMMonth;
          a_year = singleDMYear;
          break;
        } else {
            a_date = dateParts[0];
            a_month = now.getMonth() + 1;
            a_year = now.getFullYear();
            break;
        }     
    case 2:
      // Day and month entered
      if (datePos > monthPos) {
        // MD
        a_date = dateParts[1];
        a_month = dateParts[0];
      } else {
        // DM
        a_date = dateParts[0];
        a_month = dateParts[1];
      }
      a_year = now.getFullYear();
      break;
    case 3:
      a_date = dateParts[datePos];
      a_month = dateParts[monthPos];
      a_year = dateParts[yearPos];
      break;
    default:
      //case 4:
      //case 5:
      if (yearPos == 0) {
        a_year = parseInt(dateParts[0] + "" + dateParts[1], 10);
        if (datePos > monthPos) {
          // YMD
          a_date = dateParts[3];
          a_month = dateParts[2];
        } else {
          // YDM
          a_date = dateParts[2];
          a_month = dateParts[3];
        }
      } else if (yearPos == 2) {
        a_year = parseInt(dateParts[2] + "" + dateParts[3], 10);
        if (datePos > monthPos) {
          // MDY
          a_date = dateParts[1];
          a_month = dateParts[0];
        } else {
          // DMY
          a_date = dateParts[0];
          a_month = dateParts[1];
        }
      }
      break;
    //RG - Always attempt to parse the date HPS-65152 - default: return invalidFlag;
  }
  //Validate the minimum year for Sql DateTime
  if (!isNaN(a_year)) {
    a_year = parseInt(a_year, 10).validateMinimumYear();
  }

  // Time
  if (val2.indexOf(":") < 0) {
    if (val2.length === 3) {
      val2 = "0" + val2;
    }
  }

  var timeParts = val2.match(pattern);
  if (timeParts == null) timeParts = [];
  var timeEntered = true;
  switch (timeParts.length) {
    case 0:
      timeEntered = false;
      break;
    case 1:
      timeParts = [timeParts[0], 0, 0];
    default:
      timeParts = [timeParts[0], timeParts[1], 0];
      break;
    //RG Always attempt to parse the date
    //case 3: break;
    //default: return invalidFlag;
  }

  // Adjust time for AM/PM (If we decide to use this for culture differences we will need to
  // pass the the AM and PM designator to the client. For now I am assuming "AM" and "PM".
  // Get this into in .NET, DateTimeFormatInfo.AMDesignator and DateTimeFormatInfo.PMDesignator

  if (timeEntered) {
    if (timeParts[0] < 12 && val2.toUpperCase().indexOf("PM") > -1) {
      timeParts[0] = timeParts[0] - 0 + 12;
    } else if (timeParts[0] > 11 && val2.toUpperCase().indexOf("AM") > -1) {
      timeParts[0] -= 12;
    }
  }

  var retval;
  var aa_date;
  // Re-format the date based on format
  if (dateEntered && timeEntered) {
    var corrected_month = _correctMonth(a_month);
    aa_date = new Date(
      a_year,
      corrected_month,
      a_date,
      timeParts[0],
      timeParts[1],
      timeParts[2]
    );
    retval = FormatLocaleDate(aa_date, getDateTimePattern());
  } else if (dateEntered) {
    var corrected_month = _correctMonth(a_month);
    aa_date = new Date(a_year, corrected_month, a_date);
    retval = FormatLocaleDate(aa_date, getDateFormat());
  } else if (timeEntered) {
    aa_date = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      timeParts[0],
      timeParts[1],
      timeParts[2]
    );
    retval = FormatLocaleDate(aa_date, getDateTimePattern());
  } else retval = "";

  return retval;
}

var emptyTimeRegex = new RegExp("[hmst]", "gi");
var emptyDateRegex = new RegExp("[dmy]", "gi");

/** Returns the empty date format **/
function emptyDateFormat() {
  var dateFormat = getDateFormat();
  return dateFormat.replace(emptyDateRegex, " ");
}

/** Returns the empty time format **/
function emptyTimeFormat() {
  var timeFormat = getTimeFormat();
  return timeFormat.replace(emptyTimeRegex, " ");

  // The time format is pretty much all the same and all cultures
  // should understand that just ":" is the sperator betweens hours and minutes
  //return "	:";
}

/** See formatGeneral for a description */
function formatDateTime(data, values, formatParams) {
  // Localized date stuff
  var date = NaN;
  if (_isDate(data)) {
    date = data;
  } else {
    var a_time = getDateFromFormat(data, getDateTimePattern());
    //If a_time returns as NaN then try and parse the data into a date
    if (isNaN(a_time)) {
      var dateTest = Date.parse(data);
      if (_isDate(data) || !isNaN(dateTest)) {
        date = new Date(data);
      }
    } else {
      date = new Date(a_time);
    }
  }
  var strValue = "";
  if (isNaN(date) || data.length == 0) {
    values.edit = emptyDateFormat();
    values.time = emptyTimeFormat();
  } else {
    // Formats the date time using, FormatLocaleDate function which is a wrapper
    // for the VBScript function "formatdatetime"
    var strValue = FormatLocaleDate(date, getDateTimePattern());
    // Need to separate date and time
    //var theDate = strValue;
    //var theTime = "00:00:00";
    var theDate = "";
    var theTime = "";

    var spacepos = strValue.indexOf(" ");
    if (spacepos > 0) {
      theTime = strValue.substring(spacepos + 1);
      theDate = strValue.substring(0, spacepos);
    }

    if (!formatParams.noDateEntered && theDate != "") {
      values.edit = theDate;
    } else {
      values.edit = emptyDateFormat();
    }
    if (!formatParams.noTimeEntered && theTime != "") {
      values.time = theTime;
    } else {
      values.time = emptyTimeFormat();
    }
  }
  return strValue;
}

//
// Return string represention of date in form of pattern
//
function FormatDateToPattern(a_date, mask, timeOnly) {
  //Check to see if a_date is a date
  if (!_isDate(a_date)) {
    //If not a date then see if a_date can be converted to a date from the mask (date format)
    a_date = getDateFromFormat(a_date, mask);
    //Return NaN if a_date is not a date and can not be converted
    if (!_isDate(a_date)) return NaN;
  }

  var MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  var DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ];

  var SUFFIXES = [
    "st",
    "nd",
    "rd",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "st",
    "nd",
    "rd",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "th",
    "st"
  ];

  var formatted = mask != null && mask != "" && mask != " "
    ? mask
    : timeOnly
      ? "hh:mm tt"
      : "MM/dd/YYYY hh:mm tt";
  var letters = "DMYyHdhmst".split("");
  var temp = new Array();
  var count = 0;
  var regexA;
  var regexB = /\[(\d+)\]/;

  var day = a_date.getDay();
  var date = a_date.getDate();
  var month = a_date.getMonth();
  var year = a_date.getFullYear().toString();
  var hours = a_date.getHours();
  var minutes = a_date.getMinutes();
  var seconds = a_date.getSeconds();

  var formats = new Object();

  if (!timeOnly) {
    formats["D"] = date;
    formats["d"] = date;
    //formats[ 'd' ]    = date + SUFFIXES[ date - 1 ];
    formats["DD"] = date < 10 ? "0" + date : date;
    formats["dd"] = date < 10 ? "0" + date : date;
    formats["DDD"] = DAYS[day].substring(0, 3);
    formats["DDDD"] = DAYS[day];
    formats["M"] = month + 1;
    formats["MM"] = month + 1 < 10 ? "0" + (month + 1) : month + 1;
    formats["MMM"] = MONTHS[month].substring(0, 3);
    formats["MMMM"] = MONTHS[month];
    formats["Y"] =
      year.charAt(2) == "0" ? year.charAt(3) : year.substring(2, 4);
    formats["y"] =
      year.charAt(2) == "0" ? year.charAt(3) : year.substring(2, 4);
    formats["YY"] = year.substring(2, 4);
    formats["yy"] = year.substring(2, 4);
    formats["YYYY"] = year;
    formats["yyyy"] = year;
  }

  formats["H"] = hours;
  formats["HH"] = hours < 10 ? "0" + hours : hours;
  formats["h"] = hours > 12 || hours == 0 ? Math.abs(hours - 12) : hours;
  formats["hh"] = formats["h"] < 10 ? "0" + formats["h"] : formats["h"];
  formats["m"] = minutes;
  formats["mm"] = minutes < 10 ? "0" + minutes : minutes;
  formats["s"] = seconds;
  formats["ss"] = seconds < 10 ? "0" + seconds : seconds;
  formats["t"] = hours < 12 ? "A" : "P";
  formats["tt"] = hours < 12 ? "AM" : "PM";

  for (var i = 0; i < letters.length; i++) {
    regexA = new RegExp("(" + letters[i] + "+)");
    while (regexA.test(formatted)) {
      temp[count] = RegExp.$1;
      formatted = formatted.replace(RegExp.$1, "[" + count + "]");
      count++;
    }
  }

  while (regexB.test(formatted)) {
    formatted = formatted.replace(regexB, formats[temp[RegExp.$1]]);
  }

  return formatted;
}

/** See formatGeneral for a description */

// Formats date to a datePattern (J script)
function FormatLocaleDate(a_date, a_datePattern) {
  return FormatDateToPattern(a_date, a_datePattern);
}

/** See formatGeneral for a description */
function formatDate(data, values, formatParams) {
  // Localized date stuff
  var date = NaN;

  //Try and format the date that comes through.
  var a_time = getDateFromFormat(data, getDateTimePattern());

  //If a_time returns as NaN then try and parse the data into a date
  if (isNaN(a_time)) {
    var dateTest = Date.parse(data);
    if (_isDate(data) || !isNaN(dateTest)) {
      date = new Date(data);
    }
  } else {
    date = new Date(a_time);
  }

  var strValue = "";
  if (isNaN(date) || data.length == 0) {
    values.edit = emptyDateFormat();
  } else {
    // Formats the date time using, FormatLocaleDate function which is a wrapper
    // for the VBScript function "formatdatetime"
    var strValue = FormatLocaleDate(date, getDateFormat());

    if (!formatParams.noDateEntered) {
      values.edit = strValue;
    } else {
      values.edit = emptyDateFormat();
    }
  }
  return strValue;
}

//////////////////////////////////////////////////////////////////////////

/** See parseGeneral for a description */
function parseTime(val1, val2, formatParams) {
  if (val1 == "	:" || val1.length == 0) return "";

  var hours;
  var minutes;
  var seconds;

  if (!_isDate(val1)) {
    var pattern = /\d{1,2}/g;

    var timeParts = val1.match(pattern);
    if (timeParts == null) timeParts = [];
    var timeEntered = true;
    switch (timeParts.length) {
      case 0:
        return invalidFlag;
      case 1:
        timeParts = [timeParts[0], 0, 0];
        break;
      case 2:
        timeParts = [timeParts[0], timeParts[1], 0];
        break;
      case 3:
        break;
      default:
        return invalidFlag;
    }

    //Need to format based on timeFormat, not hardcoded here:
    if (timeParts.length > 1) {
      //Switch to 24 hour clock
      if (timeParts[0] < 12 && val1.toUpperCase().indexOf("PM") > -1) {
        timeParts[0] = timeParts[0] - 0 + 12;
      } else if (timeParts[0] > 11 && val1.toUpperCase().indexOf("AM") > -1) {
        timeParts[0] -= 12;
      }
    }

    var hours = parseInt(timeParts[0], 10);
    var minutes = parseInt(timeParts[1], 10);
    var seconds = parseInt(timeParts[2], 10);
  } else {
    hours = val1.getHours();
    minutes = val1.getMinutes();
    seconds = val1.getSeconds();
  }

  var today = new Date();
  var month = today.getMonth();
  var date2 = today.getDate();
  var year = today.getFullYear();

  var aa_date = new Date(year, month, date2, hours, minutes, seconds);
  var retval = FormatLocaleTime(aa_date, getTimeFormat());

  return retval;
}

// Formats date to a timePattern (J script)
function FormatLocaleTime(a_date, a_timePattern) {
  return FormatDateToPattern(a_date, a_timePattern, true); //true for timeonly.
}

/** See formatGeneral for a description */
function formatTime(data, values) {
  var date = null;
  var parts = null;
  if (data.toLocaleTimeString) {
    date = data;
  } else {
    var strValue = "";
    var pattern = /\d{1,2}/g;
    parts = data.match(pattern);

    var date = null;
    if (!parts || parts.length < 2) {
      if (values.edit != undefined) values.edit = "	:";
    } else {
      date = Date.parse(data);
    }
  }

  if (isNaN(date)) {
    if (data.toLocaleTimeString) alert("TO DO:  FIX THIS!");

    var timeParts = [parts[parts.length - 2], parts[parts.length - 1], "0"];

    //Need to format based on timeFormat, not hardcoded here:
    if (timeParts.length > 1) {
      //Switch to 24 hour clock
      if (timeParts[0] < 12 && data.toUpperCase().indexOf("PM") > -1) {
        timeParts[0] = timeParts[0] - 0 + 12;
      } else if (timeParts[0] > 11 && data.toUpperCase().indexOf("AM") > -1) {
        timeParts[0] -= 12;
      }
    }

    date = new Date();
    date.setHours(parseInt(timeParts[0], 10));
    date.setMinutes(parseInt(timeParts[1], 10));
    date.setSeconds(parseInt(timeParts[2], 10));
  }

  if (date) {
    if (typeof date === "number") {
      //Convert to Date object
      date = new Date(data);
    }

    var today = new Date();
    var month = today.getMonth();
    var date2 = today.getDate();
    var year = today.getFullYear();

    var aa_date = new Date(
      year,
      month,
      date2,
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    );
    var strValue = FormatLocaleTime(aa_date, getTimeFormat());

    if (values.edit != undefined) values.edit = strValue;
  }
  return strValue;
}

//////////////////////////////////////////////////////////////////////////

/** See parseGeneral for a description */
function parseMask(val1, val2, formatParams) {
  if (val1 == formatParams.maskHint) return "";
  else return val1;
}

function formatPhone(data, values, formatParams) {
  if (!formatParams.mask || formatParams.mask.length == 0)
    formatParams.mask = getPhoneFormat();

  return formatMask(data, values, formatParams);
}

function formatMask(data, values, formatParams) {
  if (data.length == 0) {
    values.edit = formatParams.maskHint;
  } else {
    var result = "";
    var allowSearchCharacters =
      ("" + formatParams.allowSearchCharacters).toLowerCase() == "true";

    var mask = formatParams.mask;
    var dataPos = 0;
    var found = false;

    mask = mask ? mask : "";
    // for each char in the mask
    for (
      var maskPos = 0;
      maskPos < mask.length && dataPos < data.length;
      maskPos++
    ) {
      var maskChar = mask.charAt(maskPos);
      var pattern;
      var literal = false;
      switch (maskChar) {
        case "#":
          pattern = /\d/;
          break;
        case "!":
          pattern = /[a-zA-Z]/;
          break;
        case "~":
          pattern = /[a-zA-Z]|\d/;
          break;
        case "*":
          pattern = /./;
          break;
        default:
          result += maskChar;
          literal = true;
      }
      if (literal) {
        continue;
      }

      var found = false;
      while (!found && dataPos < data.length) {
        var dataChar = data.charAt(dataPos);
        var match = dataChar.match(pattern);
        if (match && match.index != -1) {
          found = true;
          result += dataChar;
        } else if (
          allowSearchCharacters &&
          (dataChar == "%" || dataChar == "?")
        ) {
          result += dataChar;
        }
        dataPos++;
      }
    }

    // Collect remaining wildcard characters
    if (allowSearchCharacters) {
      while (dataPos < data.length) {
        var dataChar = data.charAt(dataPos);
        if (dataChar == "%" || dataChar == "?") {
          result += dataChar;
        }
        dataPos++;
      }
    }

    if (result.length == 1 && result.charAt(0) == "(")
      // if there is only one character and it is "(", then default back to the mask.
      values.edit = formatParams.maskHint;
    else values.edit = result;

    return result;
  }
}

// Returns the date format string
function getDateFormat(targetViewId) {
  return instance._DateFormat;
}

// Returns the time format string
function getTimeFormat(targetViewId) {
  return instance._TimeFormat;
}

//Returns the date time format string
function getDateTimePattern() {
  return getDateFormat() + " " + getTimeFormat();
}

// Returns the phone format mask string
function getPhoneFormat() {
  return instance._PhoneFormat;
}

// Returns the Currency Decimal Separator
function getCurrencyDecimalSeparator() {
  return instance._CurrencyDecimalSeparator;
}

// Returns the Currency Group Separator, ie. 1000's separator
function getCurrencyGroupSeparator() {
  return instance._CurrencyGroupSeparator;
}

function getCurrencySymbol() {
  return instance._CurrencySymbol;
}
